export default {
  team: {
    sendVerification: "Envoyer l’email de vérification",
    checkVerification: "J’ai vérifié mon email",
    verificationSent: "Email de vérification envoyé. Suivez son lien, puis revenez ici.",

    rsvpIdentity: "Connectez-vous avec l’adresse email vérifiée de votre invitation pour répondre. Cet accès RSVP ne donne pas accès à l’équipe organisatrice.",
    rsvpNoMatch: "Aucune invitation RSVP active ne correspond à cet email. Utilisez le compte invité ou demandez à l’organisateur de vérifier votre adresse.",
    legacyLink: 'Cet ancien lien ou code PIN ne donne plus accès à l’équipe. Demandez au propriétaire d’inviter votre adresse email, puis ouvrez Invitations reçues.',
    switchAccount: 'Utiliser un autre compte',
    unknownLegacy: 'Ancien accès sans adresse email fiable — vérifiez avec la personne.',
    sectionDenied: 'Cette rubrique ne fait pas partie de votre accès. Demandez au propriétaire de le modifier.',
  "title": "Équipe et accès",
  "description": "Choisissez qui peut vous aider et les rubriques accessibles pour cet événement.",
  "myInvitations": "Invitations reçues",
  "ownerOnly": "Seul le propriétaire peut gérer l’équipe. Sélectionnez un de vos événements pour inviter quelqu’un.",
  "invite": "Inviter une personne",
  "retry": "Réessayer",
  "members": "Personnes ayant accès",
  "owner": "Propriétaire",
  "noMembers": "Vous êtes la seule personne ayant accès. Invitez quelqu’un quand vous le souhaitez.",
  "editAccess": "Modifier l’accès",
  "remove": "Retirer l’accès",
  "invitations": "Invitations",
  "noInvitations": "Aucune invitation en attente.",
  "pending": "En attente d’acceptation",
  "cancelled": "Annulée",
  "expired": "Expirée",
  "cancelInvite": "Annuler l’invitation",
  "guestAccess": "Et les invités et anciens liens ?",
  "guestHelp": "L’équipe regroupe les personnes qui vous aident à organiser. Cet accès n’envoie pas d’invitations aux invités et ne gère pas leurs réponses RSVP. Les anciens codes PIN et liens ne donnent pas accès au nouveau système d’équipe.",
  "legacy": "{{count}} anciens accès sont à vérifier. Réinvitez les personnes de confiance par email en choisissant leurs rubriques.",
  "removeHelp": "Cette personne perdra l’accès à cet événement. Ses contributions seront conservées.",
  "cancelHelp": "Cette action annule l’invitation et retire l’accès si elle a déjà été acceptée. Les contributions sont conservées.",
  "loadError": "Impossible de charger les accès. Veuillez réessayer.",
  "actionError": "Impossible d’enregistrer. Vérifiez votre connexion et réessayez.",
  "email": "Adresse email",
  "role": "Niveau d’accès",
  "view": "Peut consulter",
  "edit": "Peut modifier",
  "roleHelp": "Consulter : lecture seule. Modifier : ajouter et modifier des éléments. Seul le propriétaire peut supprimer des éléments ou gérer les accès.",
  "sections": "Quelles rubriques ?",
  "tasks": "Tâches",
  "guests": "Invités",
  "budget": "Budget",
  "timeline": "Planning",
  "summary": "{{role}} · {{sections}} · {{event}}. L’accès concerne tous les éléments de ces rubriques, y compris les futurs ajouts.",
  "selectSections": "Sélectionnez au moins une rubrique. Le budget reste privé sauf si vous le sélectionnez.",
  "identityHelp": "Les invitations expirent après 7 jours. Le destinataire doit se connecter avec cette adresse email vérifiée. Transférer l’email ne donne pas accès à une autre personne.",
  "send": "Envoyer l’invitation",
  "sent": "Invitation envoyée. Suivez son statut dans Équipe et accès.",
  "updated": "Accès mis à jour.",
  "deliveryFailed": "L’invitation est enregistrée, mais l’email n’a pas pu être livré. Le destinataire peut se connecter et ouvrir Invitations reçues.",
  "signIn": "Se connecter pour voir les invitations",
  "verifyEmail": "Vérifiez votre adresse email, puis reconnectez-vous pour voir vos invitations.",
  "accept": "Accepter l’invitation",
  "acceptError": "Impossible d’accepter cette invitation. Elle a peut-être expiré ou été annulée.",
  "back": "Retour au tableau de bord",
  "sharedEvent": "Partagé avec vous",
  "openSection": "Ouvrir {{section}}",
  "waiting": "Invitation acceptée. Chargement de votre événement…"
},
  review: {
    "notificationDraft": "Ajustez vos préférences, puis enregistrez vos modifications.",
    "markReadError": "Impossible de mettre à jour les notifications. Réessayez."
},
  accountFlow: {
    "proTitle": "Votre formule : Pro",
    "proHelp": "Gérez vos événements, votre abonnement et vos factures depuis cet espace.",
    "manageEvents": "Gérer mes événements",
    "unsaved": "Modifications non enregistrées",
    "instantPreferences": "Les préférences sont appliquées immédiatement.",
    "comparePlans": "Comparer les formules",
    "activeEvent": "Événement actuel",
    "openEvent": "Ouvrir",
    "editDetails": "Modifier les détails",
    "switchError": "Impossible de changer d’événement. Réessayez."
},
  organization: {
    "vendorOverview": "Vue d’ensemble des prestataires",
    "grid": "Grille",
    "noVendors": "Aucun prestataire correspondant",
    "resetHelp": "Modifiez votre recherche ou réinitialisez les filtres pour retrouver vos prestataires.",
    "seatingProgress": "{{placed}} placés · {{remaining}} à placer",
    "firstTable": "Créez votre première table",
    "tableHelp": "Ajoutez une table pour placer vos invités, ou utilisez la génération automatique pour préparer un plan.",
    "addTable": "Ajouter une table"
},
  workflow: {
    "scheduleExists": "Les étapes déjà présentes ne seront pas ajoutées à nouveau.",
    "taskView": "Affichage des tâches",
    "list": "Liste",
    "kanban": "Tableau",
    "noTasksMatch": "Aucune tâche ne correspond",
    "resetTaskHelp": "Modifiez votre recherche ou réinitialisez les filtres pour retrouver vos tâches.",
    "previewSchedule": "Voir un exemple de journée",
    "scheduleHelp": "Ce modèle de mariage ajoute les étapes ci-dessous à votre programme existant. Vous pourrez ensuite adapter les horaires et les descriptions.",
    "applySchedule": "Ajouter ces étapes"
},
  journey: {
    "guestActions": "Gérer les invités",
    "openSeating": "Ouvrir le plan de table",
    "moreGuestActions": "Partager, RSVP et autres actions",
    "noGuestResults": "Aucun invité ne correspond",
    "changeGuestSearch": "Modifiez votre recherche ou réinitialisez les filtres pour retrouver vos invités.",
    "firstGuestHelp": "Ajoutez votre premier invité ou importez votre liste depuis un fichier CSV.",
    "estimatorOptional": "L’estimateur vous aide à préparer votre budget. Vous pouvez aussi commencer directement avec vos dépenses et revenir ici plus tard.",
    "skipEstimator": "Passer aux dépenses"
},
  planning: {
    "eyebrow": "Votre espace de préparation",
    "description": "Retrouvez vos priorités et avancez à votre rythme.",
    "actions": "Actions de préparation",
    "tasks": "Voir mes tâches",
    "guests": "Invités",
    "budget": "Budget",
    "pendingCount": "{{count}} à faire",
    "completedCount": "{{count}} terminées",
    "noDueDate": "Sans échéance",
    "overdue": "En retard",
    "allDone": "À jour : toutes vos tâches sont terminées."
},
  title: "Tableau de bord",
  description: "Gérez votre mariage en un coup d'œil",
  welcome: "Bienvenue sur votre tableau de bord",
  noEventSelected: "Aucun événement sélectionné",
  subtitle: "Aperçu de votre événement",
  gridView: "Vue grille",
  listView: "Vue liste",
  usage: "Utilisation",
  
  progress: {
    daysLeft: "{{count}} jours restants",
  },

  countdown: {
    title: "Compte à rebours",
    noDate: "Aucune date configurée",
    dayJ: "Jours",
    dayJ_zero: "Jour J",
    dayJ_one: "Jour",
    dayJ_other: "Jours",
    hoursJ: "heures",
    hoursJ_zero: "heure",
    hoursJ_one: "heure",
    hoursJ_other: "heures",
    minutesJ: "minutes",
    minutesJ_zero: "minute",
    minutesJ_one: "minute",
    minutesJ_other: "minutes",
  },

  // Fallback keys for raw strings
  "Arrivée des invités": "Arrivée des invités",
  "Cérémonie": "Cérémonie",
  "Cocktail": "Cocktail",
  "Dîner": "Dîner",
  "Soirée": "Soirée",
  "Préparation": "Préparation",

  budgetWidget: {
    title: "Budget",
    subtitle: "Aperçu de votre budget",
    configure: "Configurez votre budget pour voir les statistiques",
    configureButton: "Configurer"
  },

  vendorsWidget: {
    title: "Prestataires",
    subtitle: "Gérez vos prestataires",
    addVendor: "Ajouter un prestataire",
    emptyTitle: "Aucun prestataire",
    emptyDescription: "Commencez à rechercher et contacter vos prestataires",
    searchVendors: "Rechercher des prestataires",
    total: "{{count}} prestataire(s)",
    add: "Ajouter",
  },

  timelineWidget: {
    title: "Timeline",
    subtitle: "Prochains événements",
    empty: "Aucun événement à venir",
  },

  notificationsWidget: {
    title: "Notifications",
    unread: "{{count}} non lues",
    viewAll: "Voir tout",
    markAsRead: "Marquer comme lu",
    empty: "Aucune notification",
    allRead: "Toutes les notifications ont été lues"
  },

  progressWidget: {
    title: "Progression",
    global: "Progression globale",
    daysLeft: "{{count}} jours restants",
    tasks: "Tâches",
    budget: "Budget",
    guests: "Invités",
    checklist: "Liste de contrôle",
    noData: "Aucune donnée disponible"
  },

  account: {
    title: "Compte"
  },

  guestsWidget: {
    title: "Invités",
    total: "Total",
    manage: "Gérer",
    responseRate: "Taux de réponse",
    estimatedProgress: "Progression estimée",
    confirmed: "Confirmés",
    pending: "En attente",
    declined: "Refusés",
    children: "Enfants",
    teens: "Ados",
    emptyTitle: "Aucun invité",
    emptyDescription: "Commencez à créer votre liste d'invités",
    addButton: "Ajouter un invité",
  },

  weatherWidget: {
    title: "Météo",
    setLocation: "Définir le lieu",
    addWeather: "Ajouter la météo",
    searchReception: "Rechercher le lieu de réception",
    noData: "Aucune donnée météo disponible",
    humidity: "humidité",
    rain: "pluie",
    currentConditions: "Conditions actuelles à {{location}}",
    historicalTitle: "Données historiques",
    historicalNote: "Données météorologiques historiques pour la date de votre événement"
  },

  tasks: {
    title: "Tâches",
    pending: "En attente",
    viewAll: "Voir tout",
    completed: "Terminées",
    noPending: "Aucune tâche en attente",
    empty: {
      title: "Aucune tâche",
      description: "Commencez à organiser votre événement en ajoutant des tâches",
      action: "Ajouter une tâche"
    },
    categories: {
      legal: "Administratif",
      venue: "Lieu",
      other: "Autre",
      planning: "Planification",
      guests: "Invités"
    }
  },
  
  errors: {
    loadingError: "Erreur lors du chargement des données",
    noEventFound: "Aucun événement trouvé",
    markAsRead: "Erreur lors du marquage comme lu"
  },

  widgets: {
    tasks: {
      title: "Tâches",
      emptyTitle: "Commencez à organiser",
      emptyDescription: "Ajoutez les premières tâches pour commencer à organiser votre mariage",
      addButton: "Ajouter une tâche",
      completed: "Terminées",
      inProgress: "En cours",
      pending: "À faire",
      overdue: "En retard"
    },
    guests: {
      title: "Invités",
      emptyTitle: "Gérez vos invités",
      emptyDescription: "Commencez à créer votre liste d'invités",
      addButton: "Ajouter un invité",
      confirmed: "Confirmés",
      pending: "En attente",
      declined: "Refusés",
      total: "Total"
    },
    budget: {
      title: "Budget",
      emptyTitle: "Gérez votre budget",
      emptyDescription: "Commencez à suivre vos dépenses",
      addButton: "Ajouter une dépense",
      spent: "Dépensé",
      remaining: "Restant",
      total: "Total",
      currency: "€"
    },
    timeline: {
      title: "Timeline",
      emptyTitle: "Créez votre timeline",
      emptyDescription: "Ajoutez les moments clés de votre mariage",
      addButton: "Ajouter un événement",
      daysLeft: "{{count}} jours restants",
      today: "Aujourd'hui",
      upcoming: "À venir"
    }
  },

  checklistWidget: {
    title: "Liste de contrôle",
    subtitle: "Votre progression",
    noImportant: "Aucune tâche importante",
    empty: {
      title: "Aucune tâche",
      description: "Commencez à créer votre liste de contrôle",
      action: "Créer une liste"
    }
  },

  stats: {
    tasksCompleted: "Tâches terminées",
    guestsConfirmed: "Invités confirmés",
    budgetSpent: "Budget dépensé",
    daysLeft: "Jours restants"
  },

  quickActions: {
    title: "Actions rapides",
    addTask: "Ajouter une tâche",
    addGuest: "Ajouter un invité",
    addExpense: "Ajouter une dépense",
    addEvent: "Ajouter un événement"
  },

  eventDetails: {
    title: "Détails de l'événement",
    subtitle: "{{count}} détail(s) à compléter",
    complete: "Tous les détails sont renseignés !",
    partners: "Informations des partenaires",
    location: "Lieu de l'événement",
    budget: "Budget de l'événement",
    highPriority: "Priorité élevée",
    mediumPriority: "Priorité moyenne",
    lowPriority: "Priorité faible",
    partner1: "Partenaire 1",
    partner2: "Partenaire 2",
    venue: "Lieu de réception",
    venuePlaceholder: "Château de Versailles",
    address: "Adresse",
    addressPlaceholder: "Place d'Armes, 78000 Versailles",
    city: "Ville",
    cityPlaceholder: "Versailles",
    totalBudget: "Budget total (€)",
    guestCount: "Nombre d'invités estimé",
    edit: {
      partners: "Modifier les partenaires",
      location: "Modifier le lieu",
      budget: "Modifier le budget"
    }
  },

  timeline: {
    examples: {
      preparation: {
        title: "Préparation"
      },
      ceremony: {
        title: "Cérémonie"
      },
      cocktail: {
        title: "Cocktail"
      },
      dinner: {
        title: "Dîner"
      },
      party: {
        title: "Soirée"
      }
    }
  }
}
